import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmailRulesServiceProvider } from '../../api/email-rules'

const EmailRulesService = EmailRulesServiceProvider()
const name = 'getParametersEmailRule'

export default () => (asyncAction(
  name,
  EmailRulesService.getParametersEmailRule
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/email-rules/getParametersEmailRule.js